import React, {useEffect, useState} from 'react';
import {t} from "i18next";
import {Modal} from "@/components/Modal";
import {deleteAward, updateAward} from "@/service/accountApi";
import Cookies from "universal-cookie";

export const EditAwardForm = (props) => {
	const {
		showEditAwardForm,
		setShowEditAwardForm,
		awardData,
		setAwardData,
		accountDetails,
		setAccountDetails
	} = props;

	const cookies = new Cookies();
	const locale = cookies.get("locale");

	const [error, setError] = useState({});

	const [isUpdateAwardButtonDisabled, setIsUpdateAwardButtonDisabled] = useState(false);
	const [isDeleteAwardButtonDisabled, setIsDeleteAwardButtonDisabled] = useState(false);

	const [awardDetails, setAwardDetails] = useState({
		_id: '',

		awardTitle: '',
		awardDescription: '',
	});

	const [showDeleteAwardConfirmationModal, setShowDeleteAwardConfirmationModal] = useState(false);

	const handleFormData = (e) => {
		console.log(e.target.name + ': ' + e.target.value);

		setAwardDetails({
			...awardDetails,
			[e.target.name]: e.target.value
		});

		setError({
			...error,
			[e.target.name]: ""
		});
	}

	const validate = () => {
		let err = {};

		if (awardDetails.awardTitle === '') {
			err['awardTitle'] = t("AWARD_FORM.AWARD_TITLE.REQUIRED_ERROR");
		}

		if (awardDetails.awardDescription === '') {
			err['awardDescription'] = t("AWARD_FORM.AWARD_DESCRIPTION.REQUIRED_ERROR");
		}

		return err;
	}

	const handleDelete = async () => {
		console.log("Inside Handle Delete!");
		setIsDeleteAwardButtonDisabled(true);

		const awardData = {
			userAccountId: accountDetails._id,
			awardId: awardDetails._id,
		};
		const deleteAwardDataResponse = await deleteAward(awardData);

		console.log('(EditAwardForm) Delete Award Data Response: ', deleteAwardDataResponse);

		if (deleteAwardDataResponse.success) {
			setAccountDetails(deleteAwardDataResponse.data);
			setShowDeleteAwardConfirmationModal(false);
			setIsDeleteAwardButtonDisabled(false);
			setShowEditAwardForm(false);
			setIsUpdateAwardButtonDisabled(false);
			setTimeout(() => {
				setAwardDetails({
					_id: '',

					awardTitle: '',
					awardDescription: '',
				});
				setAwardData(null);
			}, 200);
		}
	}

	const handleSubmit = async () => {
		console.log("Inside Handle Submit!");
		setIsUpdateAwardButtonDisabled(true);
		const err = validate();

		if (Object.keys(err).length > 0) {
			setError(err);
			setIsUpdateAwardButtonDisabled(false);
			return;
		}

		console.log("Award Details: ", awardDetails);

		const awardData = {
			userAccountId: accountDetails._id,
			awardDetails: awardDetails,
		};
		const updateAwardDataResponse = await updateAward(awardData);

		console.log('(EditAwardForm) Update Award Data Response: ', updateAwardDataResponse);

		if (updateAwardDataResponse.success) {
			setAccountDetails(updateAwardDataResponse.data);
			setShowEditAwardForm(false);
			setIsUpdateAwardButtonDisabled(false);
			setTimeout(() => {
				setAwardDetails({
					awardTitle: '',
					awardDescription: '',
				});
			}, 200);
		}
	}

	useEffect(() => {
		if (awardData) {
			console.log("Award Data in Edit Award Form: ", awardData);
			setAwardDetails({
				_id: awardData._id,

				awardTitle: awardData.awardTitle,
				awardDescription: awardData.awardDescription,
			});
		}
	}, [awardData]);

	const handleClose = () => {
		setTimeout(() => {
			setAwardDetails({
				_id: '',

				awardTitle: '',
				awardDescription: '',
			});
		}, 200);
		setAwardData(null);
		setShowEditAwardForm(false);
	}

	return (
		<>
			{/* Edit Award Details */}
			<Modal isOpen={showEditAwardForm}>
				<div className="form-modal-container">
					{/* Header */}
					<div className={"form-modal-header-container"}>
						{/* Header Title | Close Button */}
						<div className={"flex flex-row items-center justify-between"}>
							{/* Form Title */}
							<h2>
								{t("AWARD_FORM.EDIT_TITLE")}
							</h2>

							{/* Close Button */}
							<button onClick={handleClose}>
								<img
									className={"w-[75%] h-[75%]"}
									src={"/assets/close-icon.png"}
									alt={"Close"}
									title={"Close"}
								/>
							</button>
						</div>

						{/* Divider */}
						<div className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full"}/>
					</div>

					{/* Award Details */}
					<div className={"form-modal-body-container"}>
						{/* Award Title */}
						<fieldset>
							<div className="custom-input-container">
								<label htmlFor="awardTitle">
									{t("AWARD_FORM.AWARD_TITLE.LABEL")}
								</label>

								<div className="flex-1 flex flex-col">
									<input
										id="awardTitle"
										className="custom-input"
										name='awardTitle'
										value={awardDetails.awardTitle}
										onChange={handleFormData}
									/>
									{
										error['awardTitle'] &&
										<p className="custom-input-error-message" id="error">
											{error['awardTitle']}
										</p>
									}
								</div>
							</div>
						</fieldset>

						{/* Award Description */}
						<fieldset>
							<div className="custom-input-container">
								<label htmlFor="awardDescription">
									{t("AWARD_FORM.AWARD_DESCRIPTION.LABEL")}
								</label>

								<div className="flex-1 flex flex-col">
                                <textarea
	                                id="awardDescription"
	                                className="custom-input"
	                                name='awardDescription'
	                                value={awardDetails.awardDescription}
	                                onChange={handleFormData}
                                />
									{
										error['awardDescription'] &&
										<p className="custom-input-error-message" id="error">
											{error['awardDescription']}
										</p>
									}
								</div>
							</div>
						</fieldset>
					</div>

					{/* Footer */}
					<div className={"form-modal-footer-container"}>
						{/* Divider */}
						<div className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full"}/>

						{/* Delete | Submit */}
						<div className="flex items-center justify-between">
							{/* Delete Button */}
							<button
								disabled={isDeleteAwardButtonDisabled || isUpdateAwardButtonDisabled}
								onClick={() => setShowDeleteAwardConfirmationModal(true)}
								className="form-modal-footer-container-delete-button"
							>
								<img
									src="/assets/delete-icon-filled-light.png"
									alt="Delete"
								/>
								<p>
									{t("AWARD_FORM.DELETE")}
								</p>
							</button>

							{/* Submit Button */}
							<button
								disabled={isUpdateAwardButtonDisabled || isDeleteAwardButtonDisabled}
								onClick={handleSubmit}
								className="form-modal-footer-container-submit-button"
							>
								<p>
									{t("AWARD_FORM.EDIT_SUBMIT")}
								</p>
								<svg
									viewBox="0 0 6 6"
									fill="none"
									id={"arrow-icon"}
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M3 1L5 3L3 5"
										id={"arrow-icon-tip"}
										stroke="black"
										strokeLinecap="square"
									/>
									<path
										d="M1 3L4 3"
										id={"arrow-icon-line"}
										stroke="black"
										strokeLinecap="square"
									/>
								</svg>
							</button>
						</div>
					</div>
				</div>
			</Modal>

			{/* Delete Award */}
			<Modal isOpen={showDeleteAwardConfirmationModal}>
				<div className="delete-modal-container">
					{/* Header */}
					<div className={"delete-modal-header-container"}>
						{/* Header Title | Close Button */}
						<div className={"flex flex-row items-center justify-between"}>
							{/* Form Title */}
							<h2>
								{t("AWARD_FORM.DELETE_MODAL.TITLE")}
							</h2>

							{/* Close Button */}
							<button
								onClick={() => setShowDeleteAwardConfirmationModal(false)}
							>
								<img
									className={"w-[75%] h-[75%]"}
									src={"/assets/close-icon.png"}
									alt={"Close"}
									title={"Close"}
								/>
							</button>
						</div>

						{/* Divider */}
						<div className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full"}/>
					</div>

					{/* Content */}
					<div className={"delete-modal-body-container"}>
						<p>
							{
								locale === "en"
									?
									<>
										{t("AWARD_FORM.DELETE_MODAL.DESCRIPTION", {
											pronoun: window.location.pathname.includes("personal-profile") ? "your" : "their"
										})}
										<span className={"!font-custom-semi-bold underline"}>
                                            {awardDetails.awardTitle}
                                        </span>
										?
									</>
									:
									<>
										{t("AWARD_FORM.DELETE_MODAL.DESCRIPTION_P1", {
											pronoun: window.location.pathname.includes("personal-profile") ? "आपले" : "त्यांचे"
										})}
										<span className={"!font-custom-semi-bold underline"}>
                                            {awardDetails.awardTitle}
                                        </span>
										{t("AWARD_FORM.DELETE_MODAL.DESCRIPTION_P2")}
									</>
							}
						</p>
					</div>

					{/* Footer */}
					<div className={"delete-modal-footer-container"}>
						{/* Divider */}
						<div className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full"}/>

						{/* Delete | Update */}
						<div className="flex flex-row items-center justify-between">
							{/* Cancel Button */}
							<button
								disabled={isDeleteAwardButtonDisabled}
								onClick={() => setShowDeleteAwardConfirmationModal(false)}
								className="delete-modal-footer-container-cancel-button"
							>
								<p>
									{t("AWARD_FORM.DELETE_MODAL.CANCEL")}
								</p>
								<svg
									viewBox="0 0 6 6"
									fill="none"
									id={"arrow-icon"}
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M3 1L5 3L3 5"
										id={"arrow-icon-tip"}
										stroke="black"
										strokeLinecap="square"
									/>
									<path
										d="M1 3L4 3"
										id={"arrow-icon-line"}
										stroke="black"
										strokeLinecap="square"
									/>
								</svg>
							</button>

							{/* Delete Button */}
							<button
								disabled={isDeleteAwardButtonDisabled}
								onClick={handleDelete}
								className="delete-modal-footer-container-delete-button"
							>
								<img
									src="/assets/delete-icon-filled-light.png"
									alt="Delete"
								/>
								<p>
									{t("AWARD_FORM.DELETE_MODAL.DELETE")}
								</p>
							</button>
						</div>
					</div>
				</div>
			</Modal>
		</>
	);
}
